import { axiosInstance as request } from '@api/rest.service'

const api = '/custom-forms'

/**
 * @description GET /custom-forms
 * @returns {AxiosPromise<any>}
 */
export const GET_CUSTOM_FORMS = () => request.get(api)

/**
 * @description GET /custom-forms/create
 * @returns {AxiosPromise<any>}
 */
export const GET_CUSTOM_FORMS_CREATE = () => request.get(`${api}/create`)

/**
 * @description POST /custom-forms
 * @returns {AxiosPromise<any>}
 */
export const CREATE_CUSTOM_FORM = payload => request.post(api, payload)

/**
 * @description GET /custom-forms/{id}
 * @returns {AxiosPromise<any>}
 */
export const GET_CUSTOM_FORM = id => request.get(`${api}/${id}`)

/**
 * @description PUT  /custom-forms/{id}
 * @returns {AxiosPromise<any>}
 */
export const UPDATE_CUSTOM_FORM = (id, payload) => request.put(`${api}/${id}`, payload)

/**
 * @description GET /custom-forms/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export const GET_CUSTOM_FORM_DELETE_CONFIRMATION = id => request.get(`${api}/${id}/delete-confirmation`)

/**
 * @description DELETE /custom-forms/{id}
 * @returns {AxiosPromise<any>}
 */
export const DELETE_CUSTOM_FORM = id => request.delete(`${api}/${id}`)

/**
 * @description GET /custom-forms/exists (+ params)
 * @returns {AxiosPromise<any>}
 */
export const CUSTOM_FORM_EXISTS = params => request.get(`${api}/exists`, { params })
